import React from 'react'
import TextField from '../../../baseApp/shared/components/fields/textField/TextField';
import { I18n } from 'react-redux-i18n';
import Alert from '../../../baseApp/shared/components/alerts/Alert';
import FormButtons from "../../../baseApp/shared/components/others/formButtons/FormButtons";
import SelectField from './../../../baseApp/shared/components/fields/selectField/SelectField';

const VisitsForm = ({
    visitFormData: {
        visitorEmail,
        visitHost,
        visitorName,
        company,
        buildingId,
        mobilePhone
    },
    buildingList = [],
    alert,
    createMode,
    personalAreaMode,
    handleFieldChange,
    handleOnFieldBlur,
    handleSubmitClick,
    handleBackClick,
}) => {
    return <div className="form-container">
        <div className="form">
            <Alert
                {...alert}
            />
            {!personalAreaMode &&
                <div className="header">
                    {buildHeader(createMode)}
                </div>
            }
            <div className="fields">
                <div id="visit-fields-1" className="row">
                    <SelectField
                        value={buildingId.value}
                        label={I18n.t("visits.form.building")}
                        options={buildingList}
                        handleFieldChange={value => handleFieldChange("buildingId", value)}
                        themeName="form"
                        error={buildingId.error}
                        width={4}
                    />
                    <TextField
                        value={visitHost.value}
                        label={I18n.t("visits.form.visitHost")}
                        handleFieldChange={value => handleFieldChange("visitHost", value)}
                        themeName="form"
                        error={visitHost.error}
                        width={4}
                    />
                </div>
                <div id="visit-fields-2" className="row mb-3">
                    <TextField
                        value={visitorEmail.value}
                        label={I18n.t("visits.form.visitorEmail")}
                        handleFieldChange={value => handleFieldChange("visitorEmail", value)}
                        handleFieldBlur={() => handleOnFieldBlur("visitorEmail")}
                        themeName="form"
                        error={visitorEmail.error}
                        width={4}
                    />
                    <TextField
                        value={visitorName.value}
                        label={I18n.t("visits.form.name")}
                        handleFieldChange={value => handleFieldChange("visitorName", value)}
                        themeName="form"
                        error={visitorName.error}
                        width={4}
                    />
                </div>
                <div id="visit-fields-3" className="row">
                    <TextField
                        value={company.value}
                        label={I18n.t("visits.form.company")}
                        handleFieldChange={value => handleFieldChange("company", value)}
                        themeName="form"
                        error={company.error}
                        width={4}
                    />
                    <TextField
                        value={mobilePhone.value}
                        label={I18n.t("visits.form.mobilePhone")}
                        handleFieldChange={value => handleFieldChange("mobilePhone", value)}
                        handleFieldBlur={() => handleOnFieldBlur("mobilePhone")}
                        themeName="form"
                        type='number'
                        error={mobilePhone.error}
                        width={4}
                    />
                </div>
            </div>
            <div className="buttons">
                <button
                    className=" mt-3 btn btn-primary"
                    onClick={handleSubmitClick}
                >
                    {I18n.t("forms.save")}
                </button>
            </div>
        </div>
        <div className="form-options">
            <FormButtons
                hasDelete={false}
                hasEdit={false}
                handleBackClick={handleBackClick}
            />
        </div>
    </div>
};

function buildHeader(createMode, editMode) {
    return createMode ?
        I18n.t("visits.form.headers.create") :
        editMode ?
            I18n.t("visits.form.headers.edit") :
            I18n.t("visits.form.headers.view");
}

export default VisitsForm;